<h2 mat-dialog-title class="error-color">Not an Admin</h2>

<mat-dialog-content class="mat-typography">
  <h3>Login as an administrator to access this content.</h3>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="true" class="border-2 shade" cdkFocusInitial>Okay</button>
</mat-dialog-actions>
